import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../../common/components/SearchBar';
import { Pages } from '../../../common/constants/Pages';
import { Organization } from '../../../common/types/Organization';
import OrganizationsTable, {
  Order,
} from '../../components/OrganizationsTable/OrganizationsTable';

import '../AdminContent.scss';
import useFilteredOrganizations from '../../hooks/useFilteredOrganizations';

const OrganizationsScreen: React.FC = () => {
  const [searchText, setSearchText] = React.useState<string | undefined>(
    undefined
  );
  const navigate = useNavigate();

  const [sortParams, setSortParams] = React.useState<{
    sortField?: string;
    direction?: string;
  }>({ sortField: 'createdAt', direction: 'ASC' });

  const rowsPerPage = 30;

  const {
    filteredResults: results,
    isLoading,
    total,
    page,
    setPage,
  } = useFilteredOrganizations(rowsPerPage, sortParams, searchText);

  const handleClear = () => {
    setSearchText(undefined);
  };

  const handleSearch = (text: string) => {
    setSearchText(text);
  };

  const requestSort = (property: keyof Organization, order: Order) => {
    let sortField: string = property;
    sortField = property;
    setSortParams({ sortField, direction: order.toUpperCase() });
  };

  return (
    <Box className='white-background min-height-100'>
      <Box className='content-wrapper'>
        <Box className='row-wrapper'>
          <SearchBar
            handleClear={handleClear}
            handleSearch={handleSearch}
            placeholder='Search'
          />
          <Box className='filters-row'>
            <Button
              onClick={() =>
                navigate(Pages.getRoute(Pages.createOrganization, 'add'))
              }
              startIcon={<AddIcon htmlColor='#ffffff' />}
              disableElevation
              color='primary'
              variant='contained'
              sx={{
                borderRadius: '40px',
                px: '36px',
                height: '50px',
              }}
            >
              <Typography color='white'>Add Organization</Typography>
            </Button>
          </Box>
        </Box>
        <OrganizationsTable
          requestSort={requestSort}
          isLoading={isLoading}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          total={total}
          organizations={results}
        />
      </Box>
    </Box>
  );
};

export default OrganizationsScreen;
